import React, { useState, useEffect } from "react";
import { Switch } from "@/components/ui/switch";

function AssignGrandParentRow({ gpData, handleToggleGP }) {
    const [isEnabled, setIsEnabled] = useState(gpData.gpAdded === 'Yes');

    useEffect(() => {
        setIsEnabled(gpData.gpAdded === 'Yes');
    }, [gpData.gpAdded]);

    const handleFlip = () => {
        try {
            const newValue = !isEnabled;
            setIsEnabled(newValue);
            handleToggleGP(gpData.userName);
        } catch (err) {
            // error handled by parent
        }
    };

    return (
        <div className="grid grid-cols-5 px-3 py-2.5 text-sm items-center border-t">
            <div className="font-medium truncate pr-2">{gpData.userName}</div>
            <div className="truncate pr-2">{gpData.fullName}</div>
            <div className="truncate pr-2 text-muted-foreground" title={gpData.email}>{gpData.email}</div>
            <div className="font-mono">${gpData.gcComm}</div>
            <div>
                <Switch
                    id={`flip-${gpData.userName}`}
                    checked={isEnabled}
                    onCheckedChange={handleFlip}
                />
            </div>
        </div>
    );
}

export default AssignGrandParentRow;
